import { Injectable } from '@angular/core';
import { UrlSegment, Route, CanLoad } from '@angular/router';
import { ConfigService } from '../config.service';
import { Logger } from 'projects/common/src/app/classes';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { AuthenticationService } from 'src/app/services/authentication';

/**
 * Clase que provee metodos para el chequeo de parámetros del sistema
 */
@Injectable({
  providedIn: 'root'
})
export class CanLoadParameterCheckRouteService extends Logger implements CanLoad {

  constructor(
    private parameterService: ParameterHandlerService,
    private configService: ConfigService,
    private authService: AuthenticationService
  ) {
    super();
  }

  /**
   * Define criterio para habilitar o no la carga de la ruta solicitada
   * @param route define una configuración de ruta
   */
  public async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    const requiredConfig = this.configService.requiredParameterForModule(segments.length ? segments[0].path : null);
    if (requiredConfig && Array.isArray(requiredConfig)) {
      if (requiredConfig.length) {
        const result = await this.checkRequiredParameters(requiredConfig);
        return result;
      } else {
        return true;
      }
    } else {
      this.error('NO_CONFIG_REQUIRED_FOR_MODULE');
      return true;
    }
  }

  /**
   * Retorna una promesa que se resolvera con 'true' cuando todo los parámetros
   * requeridos por la vista se encuentren inicializados y con un valor. Se resolverá
   * con 'false' en caso contrario.
   * @param parameterCollection arreglo de parametros
   */
  protected async checkRequiredParameters(parameterCollection: string[]): Promise<boolean> {
    for (const key of parameterCollection) {
      if (this.parameterService.parameters.containsKey(key)) {
        const parameter = this.parameterService.parameters.item(key);
        if (!parameter.value) {
          // TODO mensajes a config
          this.warn(`Parámetro [${key}] no preparado`);
          const result = await parameter.serviceReference.init();
          if (result === null || result === 'undefined') {
            this.cannotContinue(key);
            return false;
          } else {
            // TODO mensajes a config
            this.log(`Parámetro [${key}] preparado.`);
          }
        } else {
          // TODO mensajes a config
          this.log(`Parámetro [${key}] preparado`);
          if (!parameter.serviceReference.isAlreadyStarted()) {
            await parameter.serviceReference.init();
          }
        }
      } else {
        // TODO mensajes a config
        this.error(`Parámetro [${key}] no ha sido suscrito`);
        this.cannotContinue(key);
        return false;
      }
    }
    return true;
  }

  private cannotContinue(parameterName: string): void {
    // TODO mensajes a config
    this.error(`No se pudo obtener valor para el parámetro [${parameterName}]. No se puede continuar.`);
    this.authService.cleanSession();
  }
}